<template>

  <div class="columns is-mobile is-centered has-background-primary p-2">
    <h1 class="title is-4 has-text-white">Gestionale LMC</h1>
  </div>

  <div class="container">
    <div class="box has-text-centered">
      <h2 class="subtitle">Accedi con le credenziali Google.</h2>
      <button class="button is-primary" @click="registrami">Login</button>
    </div>
  </div>

  <p class="centrato"> <br>Versione: {{idVersione}}</p>
</template>
  
<script setup>
  import { loginUtente } from '../code/firebase'
  import { idVersione } from '../code/utilita'

  async function registrami() {
    await loginUtente();
  }
  
</script>

<style>
    .centrato {
      text-align: center;
    }
</style>